// Third-party
import React from 'react';

// Components
import WarningModal from './WarningModal';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  show?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const FileUploaderOverwiteModal: React.FC<Props> = ({ show, onCancel, onConfirm }) => (
  <WarningModal
    show={show}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title={formatMessage('Modal.PortfolioUpload.OverwriteWarningModal.Title')}
    body={<p>{formatMessage('Modal.PortfolioUpload.OverwriteWarningModal.Body')}</p>}
  />
);

export default FileUploaderOverwiteModal;
